import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import ScrollFloat from './ScrollFloat';
import './Benefits.css';

const Benefits = () => {
  const [sectionRef, isVisible] = useScrollAnimation({ threshold: 0.1 });
  const benefits = [
    {
      metric: '10x',
      title: 'Faster Information Access',
      description: 'Reduce time spent searching for information from hours to seconds'
    },
    {
      metric: '95%',
      title: 'Accuracy Rate',
      description: 'Consistent, accurate answers based on your verified knowledge base'
    },
    {
      metric: '50%',
      title: 'Faster Onboarding',
      description: 'New employees get up to speed faster with instant access to company knowledge'
    },
    {
      metric: '24/7',
      title: 'Always Available',
      description: 'Your knowledge assistant never sleeps, available whenever your team needs it'
    }
  ];

  return (
    <section id="benefits" className="benefits">
      <div ref={sectionRef} className={`benefits-container ${isVisible ? 'animate-in' : ''}`}>
        <div className="section-header">
          <h2 className="section-title">
            <ScrollFloat speed={0.3} direction="up">Measurable Impact</ScrollFloat>
          </h2>
          <p className="section-subtitle">
            <ScrollFloat speed={0.2} direction="up">
              See the difference AIEx makes for your organization
            </ScrollFloat>
          </p>
        </div>
        <div className="benefits-grid">
          {benefits.map((benefit, index) => (
            <div key={index} className="benefit-card" style={{ transitionDelay: `${index * 0.15}s` }}>
              <div className="benefit-metric">
                <ScrollFloat speed={0.2 + (index * 0.05)} direction="up" className="metric-text">
                  {benefit.metric}
                </ScrollFloat>
              </div>
              <h3 className="benefit-title">
                <ScrollFloat speed={0.15 + (index * 0.03)} direction="up">{benefit.title}</ScrollFloat>
              </h3>
              <p className="benefit-description">{benefit.description}</p>
            </div>
          ))}
        </div>
        <div className="benefits-cta">
          <p>Ready to transform how your team accesses information?</p>
          <button 
            className="btn-primary"
            onClick={() => {
              const element = document.getElementById('cta');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            aria-label="Schedule a demo to get started"
          >
            Schedule a Demo
          </button>
        </div>
      </div>
    </section>
  );
};

export default Benefits;

